export default __webpack_public_path__ + "static/media/term-in-use.0bdc2fb5.svg";